/* Share the current article without a third-party widget. */
(function () {
    var button = document.querySelector('[data-share-story]');
    if (!button) return;
    button.hidden = false;
    button.addEventListener('click', async function () {
        var status = document.querySelector('.bh-share-status');
        try {
            if (navigator.share) {
                await navigator.share({title: document.title, url: window.location.href});
            } else if (navigator.clipboard) {
                await navigator.clipboard.writeText(window.location.href);
                status.textContent = 'Article link copied.';
            } else {
                status.textContent = 'Copy the address from your browser to share this story.';
            }
        } catch (error) {
            if (error.name !== 'AbortError') status.textContent = 'Copy the address from your browser to share this story.';
        }
    });
})();
